import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReminderService} from "app/dar/common/services/reminder/reminder.service";
import {ReminderModel} from "app/dar/common/services/reminder/reminder.model";
import {ReminderListComponent} from "app/dar/accueil/reminder-dar-nav/reminder-list/reminder-list.component";
import {SubSink} from "@Common/core/utils/subsink";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-reminder-dar-nav',
  templateUrl: './reminder-dar-nav.component.html',
  styleUrls: ['./reminder-dar-nav.component.scss']
})
export class ReminderDarNavComponent implements OnInit {
  reminders: ReminderModel[] = [];
  public get nbDossiers() {
    return this.reminders?.length || 0;
  }

  constructor(
    private reminderSvc: ReminderService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.reminderSvc.refreshReminders();
    this.reminderSvc.reminders$.subscribe(reminders => this.reminders = reminders);
  }

  viewReminder() {
    if (this.reminders?.length) {
      const dialogRef = this.dialog.open(ReminderListComponent, {data: this.reminders});
      dialogRef.updatePosition({top: '40px', right: '40px'});
      dialogRef.afterClosed().subscribe();
    }
  }
}
